<div class="avatar">
  <ng-container [ngTemplateOutlet]="link ? linkRef : imageRef" />
</div>

<ng-template #imageRef>
  <figure>
    @if (avatarUrl && !imageFailed) {
      <img [src]="avatarUrl" [alt]="name" class="image" (error)="onImageError()" />
    } @else {
      <figcaption class="initials">{{ initials }}</figcaption>
    }
  </figure>
</ng-template>

<ng-template #linkRef>
  <a [routerLink]="link" class="link">
    <ng-container [ngTemplateOutlet]="imageRef" />
  </a>
</ng-template>
